import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=bc6c6b34&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=js&"
export * from "./AddUser.vue?vue&type=script&lang=js&"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=bc6c6b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6c6b34",
  null
  
)

export default component.exports